import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetGoalList = async function(parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/goals/${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}
export const DeleteGoal = async function(goalsIds) {
    try {
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/goal`,
            data: goalsIds,
        })
    } catch (e) {
        console.error(e)
    }
}

export const CreateGoal = async function(goal) {
    try {
        if (goal === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: goal')
            )

        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/goal`,
            data: goal,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetGoal = async function(goalPublicid) {
    try {
        if (goalPublicid === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: goalPublicid')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/goal/${goalPublicid}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const UpdateGoal = async function(goal) {
    try {
        const { publicId } = goal

        if (publicId === undefined)
            return Promise.reject(new Error('Missing required  parameter: id'))

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/goal/${publicId}`,
            data: goal,
        })
    } catch (e) {
        console.error(e)
    }
}